import type { ReactNode } from 'react';
import { AppHeader } from './AppHeader';
import { AppFooter } from './AppFooter';

/**
 * PageLayout — standard page wrapper with header + footer.
 * Mirrors Flutter's Scaffold pattern used across all pages.
 */
interface PageLayoutProps {
  children: ReactNode;
  hideHeader?: boolean;
  hideFooter?: boolean;
}

export function PageLayout({
  children,
  hideHeader = false,
  hideFooter = false,
}: PageLayoutProps) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
    }}>
      {!hideHeader && <AppHeader />}
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {children}
      </main>
      {!hideFooter && <AppFooter />}
    </div>
  );
}
